import React, { useEffect, useState } from "react";
import { api, money } from "../../lib/api";
import { toast } from "sonner";
import DataTable, { Pagination } from "../../components/admin/DataTable";

const STATUSES = ["", "pending", "approved", "rejected"];

export default function AdminReturns() {
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 20 };
      if (status) params.status = status;
      const { data } = await api.get("/admin/returns", { params });
      setData(data);
    } catch { toast.error("Failed to load"); }
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status, page]);

  const decide = async (r, approved) => {
    const amountRaw = approved ? window.prompt("Refund amount (₹):", r.order?.total ?? 0) : null;
    if (approved && (amountRaw === null || amountRaw === "")) return;
    const note = window.prompt(`${approved ? "Approve" : "Reject"} note (optional):`) || "";
    try {
      const body = approved
        ? { approved: true, refund_amount: Number(amountRaw), note }
        : { approved: false, note };
      await api.put(`/admin/returns/${r.id}/approve`, body);
      toast.success(approved ? "Refund approved" : "Return rejected");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const columns = [
    { key: "order", label: "Order", render: (r) => <span className="font-mono text-xs">{r.order?.order_number || r.order_id?.slice(0, 8)}</span> },
    { key: "user", label: "Customer", render: (r) => <span>{r.user?.name || r.user?.phone || "—"}</span> },
    { key: "reason", label: "Reason", render: (r) => <span className="text-xs">{r.reason || "—"}</span> },
    { key: "refund_amount", label: "Refund", render: (r) => r.refund_amount ? money(r.refund_amount) : (r.order?.total ? money(r.order.total) : "—") },
    {
      key: "status", label: "Status",
      render: (r) => (
        <span className={`uppercase text-xs ${r.status === "approved" ? "text-green-700" : r.status === "rejected" ? "text-red-700" : "text-[hsl(var(--kb-primary))]"}`}>
          {r.status || "pending"}
        </span>
      ),
    },
    { key: "created_at", label: "Requested", render: (r) => (r.created_at || "").slice(0, 10) },
    {
      key: "actions", label: "",
      render: (r) => r.status !== "approved" && r.status !== "rejected" ? (
        <div className="flex gap-2">
          <button onClick={() => decide(r, true)} className="kb-btn-primary !py-1 !px-2 !text-[10px]" data-testid={`return-approve-${r.id}`}>Approve</button>
          <button onClick={() => decide(r, false)} className="kb-btn-outline !py-1 !px-2 !text-[10px]" data-testid={`return-reject-${r.id}`}>Reject</button>
        </div>
      ) : null,
    },
  ];

  return (
    <div data-testid="admin-returns-page">
      <div className="overline mb-2">Fulfilment</div>
      <h1 className="font-display text-4xl mb-8">Returns & Refunds</h1>

      <div className="bg-white border border-[hsl(var(--kb-border))] p-4 mb-4 flex gap-3">
        <select className="kb-input max-w-xs" value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }} data-testid="filter-status">
          {STATUSES.map((s) => <option key={s} value={s}>{s || "All statuses"}</option>)}
        </select>
      </div>

      <DataTable columns={columns} rows={data.items} loading={loading} emptyLabel="No return requests" testid="returns-table" />
      <Pagination page={page} limit={20} total={data.total} onPage={setPage} />
    </div>
  );
}
